import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import LoadingOverlay from "../mui/LoadingOverlay";
import { AddNewedges } from "../redux/edgesSlice";
import { selectnodess } from "../redux/nodesSlice";
import { useNavigate } from "react-router-dom";
import { useAddEdgeToParentMutation } from "../redux/organizationApi";
import { willCreateCycle } from "../utils/graphFormatters";

function AddParentToChild() {
  const allorganization = useSelector(selectnodess);
  const [parent, setParent] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errors, setErros] = useState({});
  const [addEdgeToParent] = useAddEdgeToParentMutation();
  const initialIds = {
    parentId: "",
    childId: "",
  };

  //// console.log(allorganization)
  const [ids, setIds] = useState(initialIds);
  useEffect(() => {
    const allparents = allorganization?.map((org) => {
      return {
        label: org.data.companyName,
        value: org.id.toString(),
      };
    });
    setParent(allparents);
  }, [allorganization]);
 

  const handelSubmit = async (e) => {
    e.preventDefault();
    const errorObject = {};

    if (ids.childId.trim() === "") {
      errorObject["childId"] = "Select Childern";
    }
    if (ids.parentId.trim() === "") {
      errorObject["parentId"] = "Select Parent";
    }
    setErros(errorObject);

    //// console.log(errors);
    if (Object.keys(errorObject).length !== 0) {
      alert("Empty Requird Feilds");
      return;
    }
    if (ids.parentId === ids.childId) {
      //// console.log("Child and Parent are same");
      alert("Child and Parent are same");
      return;
    }
    if (willCreateCycle(allorganization, ids.parentId, ids.childId)) {
      //// console.log("yes validdated")
      alert("Cannot add edge as it creates a circular relationship.")

      return; // Stop further execution
    }

    const targetNode = allorganization.find((node) => node.id === ids.childId);
  
    if (!targetNode) {
      //// console.log("target Child not found");
      alert("targetNode Child not found");
      return;
    }
    if (targetNode.isRoot === true) {
      alert("Invalid , Its Root Oragnization");
      return;
    }
    if (targetNode.parent.includes(ids.parentId)) {
      alert("Already Child");
      return;
    }
    if (targetNode.children.includes(ids.parentId)) {
      alert("Invalid Child");
      return;
    }

    try {
      setLoading(true);

      await addEdgeToParent({
        targetId: ids.childId,
        sourceId: ids.parentId,
      }).unwrap();

      //// console.log("came from server");
      dispatch(
        AddNewedges({
          id: `e-${ids.parentId}-${ids.childId}`,
          source: ids.parentId,
          target: ids.childId,
        })
      );
      navigate("/admin/ChildOragnizations");
    } catch (error) {
      //// console.log(error);
      toast.error(error?.data?.message || error?.error || "Failed to add edge");
      return; // Stop further execution on failure
    } finally {
      setErros({});
      setLoading(false);
      setIds(initialIds);
    }
  };
  return (
    <>
      <form onSubmit={handelSubmit} style={{ width: "70%", margin: "auto" }}>
        <h4 className="fw-medium fs-5 text-primary m-0">Parent</h4>
        <Select
          className="my-2"
          onChange={(e) => {
            setIds((prevState) => ({
              ...prevState,
              parentId: e.value,
            }));
          }}
          options={parent}
        />
        {errors.parentId && <p style={{ color: "red" }}>{errors.parentId}</p>}

        <h4 className="fw-light fs-5 text-primary mt-4 ">Child</h4>
        <Select
          className="my-2"
          onChange={(e) => {
            setIds((prevState) => ({
              ...prevState,
              childId: e.value,
            }));
          }}
          options={parent}
        />
        {errors.childId && <p style={{ color: "red" }}>{errors.childId}</p>}
        <div className="d-flex justify-content-center my-3 align-items-center">
          <button style={{ width: 500 }} className="btn btn-primary">
            Submit
          </button>
        </div>
      </form>
      <LoadingOverlay open={loading} />
    </>
  );
}

export default AddParentToChild;
